// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5ca595cd","598":"26d3277d","787":"9e2b7681"}[chunkId] + ".chunk.js";
};